import React from "react";
import Customers from "../../../Features/Tables/Customers";

const All = () => {
  return (
    <div>
      <Customers />
    </div>
  );
};

export default All;
